import { createSlice } from '@reduxjs/toolkit';

import { submitPersonalisationForm } from 'src/redux/personalisation/thunks/submitPersonalisationForm';
import { requestProductReviews } from 'src/redux/reviews/thunks';

export interface AccessibilityState {
  statusMessage: string;
}

export const initialState: AccessibilityState = {
  statusMessage: '',
};

export const { actions, reducer } = createSlice({
  name: 'accessibility',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestProductReviews.pending, (state, { meta }) => {
        if (!meta.arg.autoInitiated) {
          state.statusMessage = 'Loading reviews';
        }
      })
      .addCase(requestProductReviews.fulfilled, (state, { meta, payload }) => {
        if (!meta.arg.autoInitiated) {
          state.statusMessage = `Page ${payload.pagination.currentPage} of reviews loaded`;
        }
      })
      .addCase(requestProductReviews.rejected, (state, { meta }) => {
        if (!meta.arg.autoInitiated) {
          state.statusMessage = 'There was a problem loading reviews';
        }
      })
      .addCase(submitPersonalisationForm.pending, (state) => {
        state.statusMessage = 'Updating basket';
      })
      .addCase(submitPersonalisationForm.fulfilled, (state) => {
        state.statusMessage = 'Basket has been updated';
      })
      .addCase(submitPersonalisationForm.rejected, (state) => {
        state.statusMessage = 'There was a problem updating the basket';
      });
  },
});
